import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuSection } from 'src/app/models/rich-data.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {

  constructor(
    public dataServ: DataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.dataServ.categorization();
  }

  async detail(detailData: MenuSection): Promise<void> {
    this.dataServ.menuSection = detailData;

    this.dataServ.getItem(detailData.menu_categories[0].menu_items[0].id);

    if (detailData.id !== 117) {
      this.router.navigateByUrl(`/services/l/${detailData.id}/${this.dataServ.menuItem.id}`);
    } else {
      this.router.navigateByUrl(`/services/${detailData.id}/${this.dataServ.menuItem.id}`);
    }
  }
}
